import React from 'react';
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import TableBodyContent from 'common/TableBodyContent/TableBodyContent';
import { Schedule } from 'store/schedules/interfaces';
import tableHeaders from './tableHeaders';
import WorkScheduleItem from './WorkScheduleItem/WorkScheduleItem';
import getTableHeight from './getTableHeight';

interface WorkScheduleListProps {
  schedulesFetching: boolean;
  schedulesError: boolean;
  schedules: Schedule[];
  isPaginationDisplayed: boolean;
}

export default function WorkScheduleList({
  schedules,
  schedulesError,
  schedulesFetching,
  isPaginationDisplayed,
}: WorkScheduleListProps) {
  const { t } = useTranslation();

  return (
    <TableContainer
      sx={{
        height: getTableHeight({
          itemsLength: schedules.length,
          isPaginationDisplayed,
        }),
      }}
    >
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {tableHeaders.map((header) => (
              <TableCell key={header.label} align={header.align}>
                <Typography variant="tableHeader" color="text.secondary">
                  {t(header.label)}
                </Typography>
              </TableCell>
            ))}
            <TableCell colSpan={tableHeaders.length} />
          </TableRow>
        </TableHead>
        <TableBodyContent
          isError={schedulesError}
          isFetching={schedulesFetching}
          tableHeaders={tableHeaders}
          showNoDataRow={false}
        >
          {schedules.map((schedule) => (
            <WorkScheduleItem key={schedule.id} schedule={schedule} />
          ))}
        </TableBodyContent>
      </Table>
    </TableContainer>
  );
}
